import { render, staticRenderFns } from "./AttributionReminderOptions.vue?vue&type=template&id=a3c92bac"
import script from "./AttributionReminderOptions.vue?vue&type=script&lang=js"
export * from "./AttributionReminderOptions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports